import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_HRECS_LOAD,
    ACTION_HRECS_LOAD_BY_ID,

    ACTION_HRECS_SAVE,

    ACTION_HRECS_CREATE,

    ACTION_HRECS_VALIDATE,

    IHrecLoadAction,
    IHrecLoadByIdAction,
    IHrecLoadFailureAction,
    IHrecLoadSuccessAction,

    IHrecSaveAction,
    IHrecSaveSuccessAction,
    IHrecSaveFailureAction,

    IHrecCreateAction,
    IHrecCreateSuccessAction,
    IHrecCreateFailureAction,

    IHrecValidateAction,
    IHrecValidateSuccessAction,
    IHrecValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/hrec";
import { hrecsApi } from 'src/services/hrecs';

export const
    getHrecsEpic = (action$): Observable<IHrecLoadSuccessAction | IHrecLoadFailureAction> => {
        return action$
            .ofType(ACTION_HRECS_LOAD)
            .mergeMap((_action: IHrecLoadAction) => {
                return hrecsApi
                    .getHrecs()
                    .map(response =>
                        LoadSuccess(response.hrecs, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getHrecsByIdEpic = (action$): Observable<IHrecLoadSuccessAction | IHrecLoadFailureAction> => {
        return action$
            .ofType(ACTION_HRECS_LOAD_BY_ID)
            .mergeMap((action: IHrecLoadByIdAction) => {
                return hrecsApi
                    .getHrecById(action.id)
                    .map(response =>
                        LoadSuccess(response.hrec, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setHrecEpic = (action$): Observable<IHrecSaveSuccessAction | IHrecSaveFailureAction> => {
        return action$
            .ofType(ACTION_HRECS_SAVE)
            .mergeMap((action: IHrecSaveAction) => {
                return hrecsApi
                    .setHrec(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.hrec, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createHrecEpic = (action$): Observable<IHrecCreateSuccessAction | IHrecCreateFailureAction> => {
        return action$
            .ofType(ACTION_HRECS_CREATE)
            .mergeMap((_action: IHrecCreateAction) => {
                return hrecsApi
                    .createHrec()
                    .map(response =>
                        CreateSuccess(response.hrec, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateHrecEpic = (action$): Observable<IHrecValidateSuccessAction | IHrecValidateFailureAction> => {
        return action$
            .ofType(ACTION_HRECS_VALIDATE)
            .mergeMap((action: IHrecValidateAction) => {
                return hrecsApi
                    .setHrec(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.hrec, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }